import React, { useState } from "react";
import { useParams, Link, useLocation } from "react-router-dom";
import ProductsData from "../data/products.json";
import "../styles/ProductStyles.css";
import EnquiryForm from "./EnquiryForm";
import "bootstrap/dist/css/bootstrap.min.css"; // Add Bootstrap
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import { MDBBtn, MDBIcon } from "mdb-react-ui-kit";
import {
  FaShareAlt,
  FaWhatsapp,
  FaFacebook,
  FaTwitter,
  FaLink,
  FaSms,
  FaLinkedin,
  FaFileDownload,
  FaDownload,
} from "react-icons/fa";
import seoFriendlySlug from "../utils/seoFriendlySlug";
import { Helmet } from "react-helmet-async";

const ProductPage = () => {
  const isUAEPath = window.location.pathname.startsWith("/uae");
  const currentLocation = useLocation();
  const [showShare, setShowShare] = useState(false);
  const [copied, setCopied] = useState(false);

  const basePath = currentLocation.pathname.startsWith("/uae") ? "/uae" : "/";
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  const { category, subcategory, product } = useParams();
  const [isFormVisible, setIsFormVisible] = useState(false);
  console.log("==>", category, subcategory, product);

  const categoryData = ProductsData.products.find(
    (prod) =>
      prod.categoryName.toLowerCase() ===
      category.toLowerCase().replace(/-/g, " ")
  );

  if (!categoryData) {
    return <p>Category not found</p>;
  }

  const subCategoryData = categoryData.subCategories.find((sub) => {
    //   console.log(
    //   "decodeCategoryName",
    //   sub.subCategoryName.toLowerCase().replace(/[-/]/g, " "), subcategory.toLowerCase().replace(/-/g, ' ')
    // );
    return (
      seoFriendlySlug(sub.subCategoryName) === seoFriendlySlug(subcategory)
    );
  });

  if (!subCategoryData) {
    return <p>Subcategory not found1</p>;
  }

  const productData = subCategoryData.products.find((prod) => {
    const fixedProductName = encodeURIComponent(
      prod.productName.replace(/[,/]/g, "-").replace(/\//g, "-").toLowerCase()
    ); // Removes %2X (e.g., %20, %2C, etc.)

    // fixedProductName === encodeURIComponent(
    //   product.replace(/[,/]/g, "-").replace(/\//g, "-").toLowerCase()
    // console.log("url-->", seoFriendlySlug(prod.productName),seoFriendlySlug(product))

    return seoFriendlySlug(prod.productName) === seoFriendlySlug(product);
  });

  if (!productData) {
    return <p>Product not found</p>;
  }

  // console.log(
  //   "====}",
  //   encodeURIComponent(prod.productName.replace(/,/g, "-").toLowerCase()),
  //   product.toLowerCase()
  // );

  const handleWhatsappClick = () => {
    const message = `Hello, I am interested in ${productData.productName} - ${subcategory}`;
    const url = `https://api.whatsapp.com/send?phone=919599953923&text=${encodeURIComponent(
      message
    )}`;
    window.open(url, "_blank");
  };

  const handleOpenForm = () => setIsFormVisible(true);
  const handleCloseForm = () => setIsFormVisible(false);

  const productLink = `https://www.timewatchindia.com/market-place/${encodeURIComponent(
    category
  )}/${encodeURIComponent(subcategory)}/${encodeURIComponent(
    productData.productName
  )}`;

  const handleCopy = () => {
    navigator.clipboard.writeText(productLink);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <>
      {console.log("productData", subCategoryData)}
      <Helmet>
        <title>{subCategoryData.subCategoryName === "X-Ray Baggage Scanner" ? "X-Ray Baggage Scanner | Airport & Railway | " : ""} {productData.productName} | TimeWatch</title>
        <meta name="description" content={`${subCategoryData.subCategoryName === "X-Ray Baggage Scanner" ? "X-Ray Baggage Scanner | Airport & Railway | " : ""}${productData.description}`} />
        <meta property="og:title" content={`${subCategoryData.subCategoryName === "X-Ray Baggage Scanner" ? "X-Ray Baggage Scanner | Airport & Railway | " : ""}${productData.productName}`} />
        <meta property="og:description" content={`${subCategoryData.subCategoryName === "X-Ray Baggage Scanner" ? "baggage scanner X-Ray Baggage Scanner | Airport & Railway | " : ""}${productData.description}`} />
        <meta name="keywords" content={`${subCategoryData.subCategoryName === "X-Ray Baggage Scanner" ? "baggage scanner, X-Ray Baggage Scanner | Airport & Railway | " : ""}${productData.productName}, ${productData.keywords?.join(", "
          )}`}
        />

        <meta property="og:type" content="product" />
        <link
          rel="canonical"
          href={`https://www.timewatchindia.com/market-place/${seoFriendlySlug(
            category
          )}/${seoFriendlySlug(subcategory)}/${seoFriendlySlug(
            productData.productName
          )}`}
        />
      </Helmet>
      <div className="container">
        <div className="breadcrumbs" style={{ marginBottom: "3rem" }}>
          <Link
            to={`${basePath}market-place/${encodeURIComponent(category)}`}
            onClick={(e) => {
              scrollToTop();
            }}
          >
            <span style={{ color: "black" }}>{category}</span>
          </Link>
          <span style={{ fontWeight: "bold" }}> | </span>
          <Link
            to={`${basePath}market-place/${encodeURIComponent(
              category
            )}/${encodeURIComponent(subcategory)}`}
            onClick={(e) => {
              scrollToTop();
            }}
          >
            <span style={{ color: "black" }}>{subcategory}</span>
          </Link>
          <span style={{ fontWeight: "bold" }}> | </span>
          <span style={{ color: "#f14144" }}>{productData.productName}</span>
        </div>

        <h1 
        className="product-title">
          {productData.productName}
        </h1>

        <div className="container my-5">
          <div className="row g-5 g-md-5 g-lg-5 g-xxl-5">
            {/* Left Section - Product Image and Files */}
            <div className="col-12 col-md-5 px-0 mt-0 mt-md-5">
              <div className="product-image mb-4 d-flex justify-content-center position-relative">
         
                {/* Share Icon */}
                <div
                  className="share-icon"
                  onClick={() => setShowShare(!showShare)}
                >
                  <FaShareAlt size={24} />
                </div>

                {/* Image */}
                <Zoom>
                  <img
                    src={require(`../assets/products/${productData.productimg}`)}
                    alt={productData.productName}
                    className="img-fluid"
                    style={{ width: "400px", height: "auto" }}
                  />
                </Zoom>

                {/* Share Popup */}
                {showShare && (
                  <div className="share-popup">
                    {/* Social Media Row */}
                    <div className="social-links">
                      <a
                        href={`https://wa.me/?text=${encodeURIComponent(
                          productLink
                        )}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <FaWhatsapp size={24} color="green" />
                      </a>
                      <a
                        href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
                          productLink
                        )}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <FaFacebook size={24} color="blue" />
                      </a>
                      <a
                        href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
                          productLink
                        )}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <FaLinkedin size={24} color="#0077B5" />
                      </a>

                      <a
                        href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(
                          productLink
                        )}&text=Check%20this%20out!`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <FaTwitter size={24} color="skyblue" />
                      </a>
                      <a
                        href={`sms:?&body=${encodeURIComponent(
                          "Check this out: " + productLink
                        )}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <FaSms size={24} color="#CD7F32" />
                      </a>
                    </div>

                    {/* Copy Link Row */}
                    <div className="copy-link">
                      <input type="text" value={productLink} readOnly />
                      <button onClick={handleCopy}>
                        <FaLink /> {copied ? "Copied!" : "Copy"}
                      </button>
                    </div>
                  </div>
                )}
              </div>

              <div className="product-files">
              <div className="row d-flex justify-content-center">
                  {productData.files.map((file, index) => (
                    <div
                      key={index}
                      className="d-flex justify-content-center mb-3"
                    >
                      {/* Datasheet */}
                      {file.Datasheet?.link ? (
                        <a
                          href={file.Datasheet.link}
                          rel="noopener noreferrer"
                          target="_blank"
                          className="download-files"
                        >
                          <div className="download-file-icon tooltip-container">
                            <FaDownload />
                          </div>
                          <img
                            src="/assets/icons/download-datasheet.png"
                            alt="Download Datasheet"
                            className="img-fluid file-icon"
                            style={{
                              width: "100px",
                              height: "auto",
                              marginRight: "15px",
                              marginLeft: "15px",
                            }}
                          />
                        </a>
                      ) : (
                        <div className="postion-relative">
                          <div className="download-file-icon tooltip-container">
                            <FaDownload />
                          </div>
                          <img
                            src="/assets/icons/coming-soon-datasheet.png"
                            alt="Coming Soon Datasheet"
                            className="img-fluid file-icon"
                            style={{
                              width: "100px",
                              height: "auto",
                              marginRight: "15px",
                              marginLeft: "15px",
                            }}
                          />
                        </div>
                      )}

                      {/* Connection Diagram */}
                      {category !== "SOFTWARE & APPLICATIONS" &&
                        (file["Connection Diagram"]?.link ? (
                          <a
                            href={file["Connection Diagram"].link}
                            rel="noopener noreferrer"
                            target="_blank"
                            className="download-files"
                          >
                            <div className="download-file-icon tooltip-container">
                              <FaDownload />
                            </div>
                            <img
                              src="/assets/icons/download-connectiondiagram.png"
                              alt="Download Connection Diagram"
                              className="img-fluid file-icon"
                              style={{
                                width: "100px",
                                height: "auto",
                                marginRight: "15px",
                                marginLeft: "15px",
                              }}
                            />
                          </a>
                        ) : (
                          <div className="position-relative">
                            <div className="download-file-icon tooltip-container">
                              <FaDownload />
                            </div>
                            <img
                              src="/assets/icons/coming-soon-diagram.png"
                              alt="Coming Soon Connection Diagram"
                              className="img-fluid file-icon"
                              style={{
                                width: "100px",
                                height: "auto",
                                marginRight: "15px",
                                marginLeft: "15px",
                              }}
                            />
                          </div>
                        ))}

                      {/* User Manual */}
                      {file["User Manual"]?.link ? (
                        <a
                          href={file["User Manual"].link}
                          rel="noopener noreferrer"
                          target="_blank"
                          className="download-files"
                        >
                          <div className="download-file-icon tooltip-container">
                            <FaDownload />
                          </div>
                          <img
                            src="/assets/icons/download-usermanual.png"
                            alt="Download User Manual"
                            className="img-fluid file-icon"
                            style={{
                              width: "100px",
                              height: "auto",
                              marginRight: "15px",
                              marginLeft: "15px",
                            }}
                          />
                        </a>
                      ) : (
                        <div className="position-relative">
                          <div className="download-file-icon tooltip-container">
                            <FaDownload />
                          </div>
                          <img
                          src="/assets/icons/coming-soon-manual.png"
                          alt="Coming Soon User Manual"
                          className="img-fluid file-icon"
                          style={{
                            width: "100px",
                            height: "auto",
                            marginRight: "15px",
                            marginLeft: "15px",
                          }}
                        />
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Right Section - Description and Features */}
            <div className="col-md-6 ms-md-5">
              <div className="product-description mb-5">
                {productData.prodesc && (
                  <>
                    <h3 className="h4 mb-3">DESCRIPTION</h3>
                    <p className="fs-6">{productData.prodesc}</p>
                  </>
                )}
              </div>
              <div className="product-features">
                {productData.features && productData.features.length > 0 && (
                  <>
                    <h3 className="h4 mb-4">FEATURES</h3>
                    <div className="row">
                      {productData.features
                        .filter((feature) => feature) // Filter out empty/missing features
                        .map((feature, index) => (
                          <div
                            key={index}
                            className="col-6 col-md-2 col-lg-3 justify-content-center text-center mb-3"
                          >
                            <img
                              src={require(`../assets/products/features/${feature}`)}
                              alt={`feature-${index}`}
                              style={{
                                width: "50px",
                                height: "50px",
                                transition: "transform 0.2s ease",
                                cursor: "pointer",
                                margin: "auto",
                              }}
                              className="img-fluid mb-2"
                              onMouseEnter={(e) => {
                                e.currentTarget.style.transform = "scale(1.3)";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.transform = "scale(1)";
                              }}
                            />
                            <p className="fw-bold">
                              {feature
                                .replace(/\.png$|\.jpg$|\.jpeg$/i, "") // Remove only .png, .jpg, or .jpeg at the end
                                .replace(/-/g, " ")}{" "}
                              {/* Replacing '-' with space */}
                            </p>
                          </div>
                        ))}
                    </div>
                  </>
                )}

                <div className="text-center mt-4">
                  <div className="d-flex justify-content-center gap-3 flex-wrap">
                    <button
                      className="btn btn-danger"
                      style={{ cursor: "pointer" }}
                      onClick={handleOpenForm}
                    >
                      ENQUIRE NOW
                    </button>
                    <button
                      className="btn"
                      style={{
                        backgroundColor: "#25D366",
                        borderColor: "#25D366",
                        color: "black",
                        textDecoration: "none",
                      }}
                      onClick={handleWhatsappClick}
                    >
                      <MDBIcon className="me-2" fab icon="whatsapp" /> Enquire
                      on WhatsApp
                    </button>
                  </div>
                </div>
              </div>
              <div className="product-keywords" style={{ display: "none" }}>
                {productData.keywords && productData.keywords.length > 0 && (
                  <>
                    <h3 className="h4 mb-4">KeyWords</h3>
                    <div className="row">
                      <div className="col-12 text-center mb-3">
                        <p>{productData.keywords.join(", ")}</p>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>

        {productData.table && productData.table.rows.length > 0 && (
          <div className="container mt-5">
            <h2 className="text-center mb-5" style={{ fontSize: "2rem" }}>
              {productData.table.heading}
            </h2>
            <table
              className="table table-bordered"
              style={{ border: "2px solid #4a4a4a" }}
            >
              <tbody>
                {productData.table.rows.map((row, index) => (
                  <tr key={index}>
                    <td
                      className="fw-bold"
                      style={{ fontSize: "1.2rem", backgroundColor: "#ededeb" }}
                    >
                      {row.column1}
                    </td>
                    <td style={{ fontSize: "1.2rem" }}>{row.column2}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        <div className="container mt-5 table">
          {subCategoryData.products && subCategoryData.products.length > 0 && (
            // Filter out the current product and check if there are any similar products
            <>
              {subCategoryData.products.filter(
                (prod) =>
                  prod.productName.toLowerCase() !== product.toLowerCase()
              ).length > 0 && (
                <h2 className="text-center mb-4" style={{ fontSize: "2rem" }}>
                  Similar Products
                </h2>
              )}
              <div className="row">
                {subCategoryData.products
                  .filter(
                    (prod) =>
                      prod.productName.toLowerCase() !== product.toLowerCase()
                  )
                  .map((similarProduct, index) => (
                    <div key={index} className="col-md-3 col-sm-6 mb-4">
                      <div
                        className="card h-100 no-hover"
                        style={{
                          transform: "none",
                          background: "rgba(229, 229, 226, 0.4)", // Semi-transparent background
                          backdropFilter: "blur(10px)", // Glass effect with blur
                          WebkitBackdropFilter: "blur(10px)", // Safari support
                          border: "1px solid rgba(255, 255, 255, 0.2)", // Light border to enhance effect
                          borderRadius: "10px", // Rounded corners
                        }}
                      >
                        <Link
                          to={`${basePath}market-place/${seoFriendlySlug(
                            category
                          )}/${seoFriendlySlug(subcategory)}/${seoFriendlySlug(
                            similarProduct.productName
                          )}`}
                          onClick={scrollToTop}
                        >
                          <div className="card-img-top">
                            <img
                              src={`https://timewatch.co.in/products/${similarProduct.productimg}`}
                              alt={similarProduct.productName}
                              className="img-fluid"
                            />
                          </div>
                          <div className="card-body text-center text-decoration-none">
                            <p
                              className="card-title "
                              style={{ textDecoration: "none" }}
                              onMouseEnter={(e) =>
                                (e.currentTarget.style.textDecoration = "none")
                              }
                            >
                              {similarProduct.productName}
                            </p>
                          </div>
                        </Link>
                      </div>
                    </div>
                  ))}
              </div>
            </>
          )}
        </div>

        {isFormVisible && (
          <EnquiryForm
            productName={`${productData.productName} - ${subcategory}`}
            onClose={handleCloseForm}
          />
        )}
      </div>
    </>
  );
};

export default ProductPage;
